import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/inflation',
  component: () => import('../../routes/Inflation.svelte'),
  card: {
    id: 'inflation',
    title: 'Inflation Calculator',
    description: "Calculate what today's money will be worth in the future, or what a future amount is worth in today's dollars.",
    icon: 'trending_up',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/inflation',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Inflation Calculator – Future Value & Purchasing Power Calculator',
    description: 'Free inflation calculator. Calculate the future or present value of money adjusted for inflation. See how purchasing power changes over time with year-by-year breakdowns and cumulative inflation rates.',
  },
};

export default meta;
